<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="row">
    <app-input-text class="col-12 col-md-6" [control]="form.get('name')" name="company_name" [autoFocus]="true"></app-input-text>
    <app-input-text class="col-12 col-md-6" [control]="form.get('street')" name="company_street"></app-input-text>
    <app-input-text class="col-12 col-md-6" [control]="form.get('street2')" name="company_street2"></app-input-text>
    <app-input-text class="col-12 col-md-6" [control]="form.get('zip')" name="company_zip"></app-input-text>
    <app-input-text class="col-12 col-md-6" [control]="form.get('city')" name="company_city"></app-input-text>
    @if (countries.length>0) {
      <app-input-select class="col-12 col-md-6" [options]="countries"
        [control]="form.get('country')"
        name="company_country"
        optionLabel="name"
        optionValue="code"
      ></app-input-select>
    }
    @if (showInvoiceMail) {
      <app-input-text class="col-12 col-md-6" [control]="form.get('email')" name="company_invoiceEmail"></app-input-text>
      @if (showElectronicInvoiceMail) {
        <app-input-text class="col-12 col-md-6" [control]="form.get('electronic_invoice_email')" name="company_electronicInvoiceEmail"></app-input-text>
      }
    }
  </div>
  <div class="d-flex justify-content-end mt-3">
    <ng-content></ng-content>
    <app-button-submit [invalid]="form.invalid" [label]="submitButtonLabel"></app-button-submit>
  </div>
</form>
